import React from 'react';

const SplashPage: React.FC = () => {
    return (
        <div>
            <h1>Welcome to Xervix Professional Web</h1>
            <p>This is the splash page.</p>
        </div>
    );
};

export default SplashPage;